<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="completeLitersModal" persistent max-width="70%">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <img src="../assets/ok.svg" width="20%" class="ma-3 pa-1" />
          </v-row>

          <v-row align="center" justify="center">
            <h1>Certificación "Litros completos"</h1>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <p class="textCenter">Garantía única en el mercado.</p>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <ul>
                  <li>Recarga al menos con el 15% de tu tanque estacionario, esto ayuda a que tus cargas sean mas precisas.</li>
                  <li>Si tu medidor no demuestra el incremento correcto o no coincide tu ticket digital con tu carga, la gasera regresará a tu domicilio a completar tus litros faltantes.</li>
                  <li>No llenes tu tanque mas del 80%.</li>
                  <li>Si tu tanque esta vacío, no puedes hacer válida tu garantía.</li>
                </ul>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <v-btn color="primary" block rounded @click="close()"
                  >Entendido</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["completeLitersModal"]),
  },
  methods: {
    close() {
      this.completeLitersModal = false;
    },
  },
};
</script>

<style>
.textCenter {
  text-align: center;
  text-justify: distribute;
}
</style>